import { types } from 'mobx-state-tree'

import { FORTO_AVATAR, TAvatarType } from '../avatars/AvatarType'
import { COMPANY_NAME } from '../constants'
import { IActivityMessageSection, IActivityTitle, TEXT } from '../messages/MessageSectionType'
import { Activity } from './Activity'

export const BookingActivity = types.compose('BookingActivity', Activity, types.model({})).views(() => ({
  get avatarType(): TAvatarType {
    return FORTO_AVATAR
  },
  get messageContent(): IActivityMessageSection[] {
    return [
      {
        type: TEXT,
        content: 'activity-feed_booking_request_placed',
        translate: true,
      },
    ]
  },
  get title(): IActivityTitle {
    return { text: COMPANY_NAME }
  },
}))
